import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import {
  CmsArticle,
  CmsCollection,
  CmsContent,
  CmsContentType,
  CmsTaxonomy,
  CmsTeaser,
  CmsViewType,
} from '@fcom/core-api';
import { isNotBlank } from '@fcom/core';

import { getFontLevel, getHeaderLevel } from '../../services/cms-utils/cms-utils';

@Component({
  selector: 'cms-articles-with-icons',
  templateUrl: './cms-articles-with-icons.component.html',
  styleUrls: ['./cms-articles-with-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    '[class.col-1-12]': '!isFullWidth()',
  },
})
export class CmsArticlesWithIconsComponent {
  readonly CmsContentType = CmsContentType;
  readonly CmsViewType = CmsViewType;
  readonly DEFAULT_HEADER_LEVEL = 3;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input.required<CmsCollection>();

  private tags = computed<CmsTaxonomy[]>(() => this.content()?.subjectTaxonomyTags || []);

  articles = computed<CmsArticle[]>(
    () =>
      this.content().items.filter(
        (i: CmsContent): boolean => i.contentType === CmsContentType.CMArticle
      ) as CmsArticle[]
  );
  link = computed<CmsTeaser>(
    () => this.content().items.find((i: CmsContent): boolean => i.contentType === CmsContentType.CMTeaser) as CmsTeaser
  );
  hasGridClass = computed<boolean>(() => isNotBlank(this.content().gridClass));

  isFullWidth = computed<boolean>(() => this.content()?.gridClass?.includes('grid-col-12') ?? false);

  public headerLevel(): number {
    const tags: CmsTaxonomy[] = this.tags();
    return getHeaderLevel(tags) ?? this.DEFAULT_HEADER_LEVEL;
  }

  public headerFontLevel(): string {
    const tags: CmsTaxonomy[] = this.tags();
    return getFontLevel(tags)
      ? `ms-clear-t white-text text-icon-reversed ${getFontLevel(tags)}`
      : 'ms-clear-t white-text text-icon-reversed';
  }
}
